export default "__VITE_ASSET__DiNBV7Z5__"